export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}</p>
                <div style={{margin:8}}>
                <a href="https://apps.apple.com/us/app/artsko/id1582398116" alt="ios app store" >
                  <img style={{margin:8}} alt="ios app store"  src="/img/ios_app_store.svg"/>
                </a>
                <a href="https://play.google.com/store/apps/details?id=art.artsko.artsko" alt="android app store">
                  <img style={{margin:8}} height="58" alt="android app store"  src="/img/android_app_store.png"/>
                </a>
                </div>
                <a
                  href='#features'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  Learn More
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
